import getConfig from 'utils/getConfig'
import type { TenantLanguages, GlobalConfig, Tenants } from 'entities/Config'

export const getTenant = (): Tenants =>
  (global as any)._saeConversational?.tenant || 'com'

export const getTenantLanguage = (): TenantLanguages =>
  (global as any)._saeConversational?.language || 'de'

export const getGlobalConfig = (): GlobalConfig | undefined => {
  const [tenant, language] = [getTenant(), getTenantLanguage()]
  const config = getConfig()
  return config?.global?.[tenant]?.[language]
}

const gtmContainerId = {
  com: 'GTM-PVRM45G',
  at: 'GTM-5MBPK',
  erx: 'GTM-PVRM45G',
  it: 'GTM-TWNBFW7',
  be: 'GTM-T7HHPSRG',
}

export const getGtmContainerId = () => {
  const tenant = getTenant()

  return gtmContainerId[tenant]
}
